import { FeatureVoting } from './FeatureVoting'

export default function FeatureVotingPage() {
  return (
    <div style={{ padding: '24px' }}>
      <FeatureVoting />
    </div>
  )
}